module.exports = __webpack_public_path__ + "img/0Q3B9422-41_H_FoamcoreMatted_MockedUp.96a2f527.jpg";